import React from 'react';
export function SummerCampFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-3176">
      Summer Camp Questions
    </h2>;
}